import { useEffect } from 'react';
import { useGoogleLogin } from '../../hooks/useGoogleLogin';

export default function GoogleCallback() {
  const { handleCallback } = useGoogleLogin();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

  if (token) {
    handleCallback(token); // salva token, atualiza AuthContext
  } else {
    window.location.href = '/';
  }
  }, [handleCallback]);

  return <p>Autenticando com Google...</p>;
}